import React, { Component } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'

class PantheonFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}
	
	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}
	
	render(){
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup 
					activeKey={activeFAQKey} 
					onSelect={this.handleFAQSelect} 
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list" 
					accordion
					id="pantheon"
				>
				</PanelGroup>
			</div>
		)	
	}
}

export default PantheonFAQs
